/**
 * @component PageHero
 * @description 내부 페이지의 제목/브레드크럼을 일관된 비주얼로 노출하는 공통 히어로 컴포넌트입니다.
 * @usage Home을 제외한 페이지 상단에서 섹션 맥락과 현재 위치를 안내할 때 사용됩니다.
 */

export default function PageHero({ title, trail, className = '', hideTitle = false }) {
  const heroClassName = ['page-hero', className].filter(Boolean).join(' ');

  return (
    <section className={heroClassName}>
      <div className="container">
        <p className="page-hero-breadcrumb">Home / {trail.join(' / ')}</p>
        {!hideTitle && <h1>{title}</h1>}
      </div>
    </section>
  );
}
